import "./SurfsharkVsCyberGhost.module.css";
import Header from "@/reusable_sections/Header";
import ComparisonHero from "./sections/ComparisonHero";
import Vpncomparisonprotocol from "./sections/Vpncomparisonprotocol";
import Relatedvpnarticles from "./sections/Relatedvpnarticles";
import Footer from "@/reusable_sections/Footer";
export default function SurfsharkVsCyberGhostPage() {
  return <div>
      <Header />
      <ComparisonHero />
      <Vpncomparisonprotocol />
      <Relatedvpnarticles />
      <Footer />
    </div>;
}